import { IntlFormatters } from 'react-intl';

import Joi from 'joi';

import { URLRegEx } from '@marketplace/common';

export const descriptionValidationSchema = ({
  formatMessage,
}: Pick<IntlFormatters, 'formatMessage'>)=> {
  const descriptionDescriptionLabel = formatMessage({
    id: 'description_descriptionLabel',
  });

  const descriptionURLLabel = formatMessage({
    id: 'description_descriptionURL',
  });

  return Joi.object({
    url: Joi.string()
      .trim()
      .allow('')
      .max(2000)
      .pattern(URLRegEx)
      .messages({
        'string.pattern.base': formatMessage(
          { id: 'generalForm_validation_uri' },
          { field: descriptionURLLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: descriptionURLLabel, min: 1, max: 2000 }
        ),
      }),
    long_description: Joi.string()
      .allow('')
      .min(15)
      .max(5000)
      .messages({
        'string.pattern.base': formatMessage(
          { id: 'generalForm_validation_allowed' },
          { field: descriptionDescriptionLabel }
        ),
        'string.max': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: descriptionDescriptionLabel, min: 15, max: 5000 }
        ),
        'string.min': formatMessage(
          { id: 'generalForm_validation_range' },
          { field: descriptionDescriptionLabel, min: 15, max: 5000 }
        ),
      }),
    icon: Joi.optional(),
    preview_images: Joi.optional(),
    application_id: Joi.string().allow('')
  });
};
